import { TranslationContextProvider } from 'schummar-translate/react';
import ButtonPrimary from '../basePageComponents/buttons/ButtonPrimary';
import './WelcomeDetails.css';
import t from '../translations/translate.ts';
import TextField from '../fields/TextField.js';
import TextFieldType from '../enums/TextFieldTypes.js';
import { useState, useEffect } from 'react';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { ifRightToLeft } from '../utils/ifLangDir.js';
import { useLocale } from '../LocaleContext';
import CONSTS from '../Constants.js';
import axios from 'axios';
import Loader from '../Loader';

export default function OtpVerification({ phoneNumber, phoneCode, onVerified, onError }) {
    const { locale } = useLocale();
    const [otpCode, setOtpCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [codeSent, setCodeSent] = useState(false);

    const fullPhone = phoneCode + phoneNumber;

    useEffect(() => {
        async function sendCode() {
            try {
                setLoading(true);
                await axios.post(`${CONSTS.BASE_API_URL}/auth/code`, {
                    phone_number: fullPhone
                }, {
                    headers: { 'Content-Type': 'application/json' }
                });
                setCodeSent(true);
            } catch (error) {
                console.log("auth/code error", error);
                if (error.response && error.response.data && error.response.data.error) {
                    NotificationManager.error(error.response.data.error, t('signUpRequestError'));
                } else {
                    NotificationManager.error(error.toString(), t('signUpRequestError'));
                }
                if (onError) onError();
            } finally {
                setLoading(false);
            }
        }
        sendCode();
    }, []);

    if (loading && !codeSent) {
        return <Loader />;
    }

    return <TranslationContextProvider locale={locale}>
        <div
            style={{
                direction: ifRightToLeft() ? 'rtl' : 'ltr',
            }}
            className="base_background WelcomeDetails_root">

            <div className="WelcomeDetails_title _black_28 no_select">
                {t('otpVerification')}
            </div>

            <div className="WelcomeDetails_form no_select">
                <div className='_grey_16' style={{ marginBottom: 8 }}>
                    {t('otpCodeSent')}
                </div>
                <div className='_grey_16' style={{ marginBottom: 16, fontWeight: 'bold' }}>
                    {fullPhone}
                </div>
                <TextField
                    value={otpCode}
                    onChange={(e) => setOtpCode(e.target.value.replace(/[^0-9]/g, ''))}
                    type={TextFieldType.TEXT}
                />
            </div>
            <br /><br /><br /><br /><br /><br /><br /><br />
        </div>
        <div className="WelcomeFooter base_background">
            <ButtonPrimary
                disable={otpCode.length < 4 || loading}
                onClick={() => {
                    if (otpCode.length >= 4) {
                        onVerified(otpCode);
                    }
                }}
                width='calc(100% - 15px)'
                txt={loading ? '...' : (t('verify') || 'Verify')}
            />
        </div>
        <NotificationContainer />
    </TranslationContextProvider>;
}
